import React from "react";

function Header({ scrollPosition, viewportHeight, scrollIndex, menuBgFromIndex }) {

  return (
    <header style={{backgroundColor: menuBgFromIndex(scrollIndex)}}>
      <h1>Master Sudoku Challenge</h1>
      {scrollIndex === 0 && <nav>
        <ul>
          <li>
            <a href="#hero">Home</a>
          </li>
          <li>
            <a href="#features">Features</a>
          </li>
          <li>
            <a href="#screenshots">Screenshots</a>
          </li>
          <li>
            <a href="#download">Download</a>
          </li>
        </ul>
      </nav> }
    </header>
  );
}

export default Header;
